import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select } from 'redux-saga/effects';
// import * as RentContractMoniesApi from '../Api/RentContractMoniesApi.ts_';
// import * as RentContractAccountingApi from '../Api/RentContractAccountingApi.ts_';
import * as owner_remittance_check_logs_api from '../Api/owner_remittance_check_logs_api';
import * as furi_list_api from '../Api/furi_list_api';

// import * as UsersApi from './Api/UsersApi';
// import * as RentAgentsApi from './Api/RentAgentsApi';
// import * as Kyousai from '../../Kyousai/Saga/Kyousai';
///types


//export interface HogeState {
//    responselist: string[];
//    responseedit: number;
//}
export interface State {
    // rent_contract_monies:any;
    direct_debit_list: any;
    pre_direct_debit_list: any;
    direct_debit_types: any;
    kozalist: any;
    direct_debit_search_form: any;
    addlist: any;
    changelist: any;
    pre_month_list: any;
    this_month_list: any;
    deletelist: any;
    direct_debit_details: any;
    direct_debit_loading: boolean;
    // search_contract_date_start: any;
    // search_contract_date_end: any;
    // search_tatemono_name: any;
    // parking_check_loading: number;
    // net_check_loading: number;

    // energization_check_loading: number;

    // electronics_check_loading: number;
    // wifi_check_loading: number;
    // search_loading: boolean;
    // owner_tel_check_loading: number;
}
const initialState: State = {

    // rent_contract_monies: [],

    direct_debit_list: [],
    pre_direct_debit_list: [],
    direct_debit_types: [],
    kozalist: [],
    direct_debit_details: [],
    direct_debit_loading: false,
    direct_debit_search_form: {
        hiki_date: '2020/6/20',
        // search_contract_date_start: null,
        // search_contract_date_end: null,
        // search_tatemono_name: null,
        // search_completed: false,
    },
    addlist: [],
    changelist: [],
    pre_month_list: [],
    this_month_list: [],
    deletelist: [],
    // search_contract_date_start: null,
    // search_contract_date_end: null,
    // search_tatemono_name: "",

    // parking_check_loading: 0,
    // net_check_loading: 0,

    // energization_check_loading: 0,

    // electronics_check_loading: 0,
    // wifi_check_loading: 0,
    // search_loading: false,
    // owner_tel_check_loading: 0,

    // users: [],
    // rentAgents: [],
    // rentMReasons: [],



}



///action 
const actionCreator = actionCreatorFactory();



export const get_direct_debit_list = actionCreator<any>('GET_DIRECT_DEBIT_LIST');
export const change_direct_debit_list = actionCreator("CHANGE_DIRECT_DEBIT_LIST");

export const get_pre_direct_debit_list = actionCreator<any>("GET_PRE_DIRECT_DEBIT_LIST");
export const change_pre_direct_debit_list = actionCreator<any>("CHANGE_PRE_DIRECT_DEBIT_LISTT");

export const get_direct_debit_types = actionCreator<any>('GET_DIRECT_DEBIT_TYPES');
export const change_direct_debit_types = actionCreator("CHANGE_DIRECT_DEBIT_TYPES");


export const get_kozalist = actionCreator<any>('GET_KOZALIST');
export const change_kozalist = actionCreator("CHANGE_KOZALIST");


export const change_direct_debit_search_form = actionCreator<any>("CHANGE_DIRECT_DEBIT_SEARCH_FROM");


export const change_addlist = actionCreator<any>('CHANGE_ADDLIST');
export const change_changelist = actionCreator<any>('CHANGE_CHANGELIST');
export const change_pre_month_list = actionCreator<any>('CHANGE_PRE_MONTH_LIST');
export const change_this_month_list = actionCreator<any>('CHANGE_THIS_MONTH_LIST');

export const change_deletelist = actionCreator<any>('CHANGE_DELETELIST');

export const get_direct_debit_details = actionCreator<any>('GET_DIRECT_DEBIT_DETAILS');
export const change_direct_debit_details = actionCreator<any>('CHANGE_DIRECT_DEBIT_DETAILS');

export const change_direct_debit_loading = actionCreator<boolean>('CHANGE_DIRECT_DEBIT_LOADING');

export const direct_debit_check_Reducer = reducerWithInitialState(initialState)
    .case(change_direct_debit_list, (state, payload) => ({ ...state, direct_debit_list: payload }))
    .case(change_pre_direct_debit_list, (state, payload) => ({ ...state, pre_direct_debit_list: payload }))
    .case(change_direct_debit_types, (state, payload) => ({ ...state, direct_debit_types: payload }))
    .case(change_direct_debit_search_form, (state, payload) => ({ ...state, direct_debit_search_form: payload }))
    .case(change_kozalist, (state, payload) => ({ ...state, kozalist: payload }))
    .case(change_addlist, (state, payload) => ({ ...state, addlist: payload }))
    .case(change_changelist, (state, payload) => ({ ...state, changelist: payload }))
    .case(change_pre_month_list, (state, payload) => ({ ...state, pre_month_list: payload }))
    .case(change_this_month_list, (state, payload) => ({ ...state, this_month_list: payload }))

    .case(change_deletelist, (state, payload) => ({ ...state, deletelist: payload }))

    .case(change_direct_debit_details, (state, payload) => ({ ...state, direct_debit_details: payload }))

    .case(change_direct_debit_loading, (state, payload) => ({ ...state, direct_debit_loading: payload }))


// .case(change_net_check_loading, (state, payload) => ({ ...state, net_check_loading: payload }))
// .case(change_energization_check_loading, (state, payload) => ({ ...state, energization_check_loading: payload }))
// .case(change_wifi_check_loading, (state, payload) => ({ ...state, wifi_check_loading: payload }))
// .case(change_electronics_check_loading, (state, payload) => ({ ...state, electronics_check_loading: payload }))
// .case(change_search_form, (state, payload) => ({ ...state, search_form: payload }))
// .case(change_search_loading, (state, payload) => ({ ...state, search_loading: payload }))

// .case(change_owner_tel_check_loading, (state, payload) => ({ ...state, owner_tel_check_loading: payload }))


// .case(change_search_contract_date_start, (state, payload) => ({ ...state, search_contract_date_start: payload }))
// .case(change_search_contract_date_end, (state, payload) => ({ ...state, search_contract_date_end: payload }))
// .case(change_search_tatemono_name, (state, payload) => ({ ...state, search_tatemono_name: payload }))



//.case(getRentMMedeasFailure, (state, payload) => ({ ...state, rentMMedeas: payload }))
// .case(getUsersSuccess, (state, payload) => ({ ...state, users: payload }))
// .case(getUsersFailure, (state, payload) => ({ ...state, users: payload }))
// .case(getRentAgentsSuccess, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentAgentsFailure, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentMReasonsSuccess, (state, payload) => ({ ...state, rentMReasons: payload }))
// .case(getRentMReasonsFailure, (state, payload) => ({ ...state, rentMReasons: payload }));







// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const direct_debit_check_Saga = [
    //     takeEvery('GET_RENT_CONTRACT_MONIES', handleRequestMoney),
    // takeEvery('GET_RENT_CONTRACT_ACCOUNTING', handle_get_rent_contract_accounting),
    takeEvery('GET_DIRECT_DEBIT_LIST', handle_get_direct_debit_list),
    // takeEvery('GET_PRE_DIRECT_DEBIT_LIST', handle_get_pre_direct_debit_list),
    takeEvery('GET_DIRECT_DEBIT_TYPES', handle_get_direct_debit_types),
    takeEvery('GET_KOZALIST', handle_get_kozalist),
    takeEvery('GET_DIRECT_DEBIT_DETAILS', handle_get_direct_debit_details),

    // takeEvery('ENERGIZATION_CHECKED', handle_energization_checked),

    // takeEvery('ELECTRONICS_CHECKED', handle_electronics_checked),
    // takeEvery('WIFI_CHECKED', handle_wifi_checked),
    // // takeEvery('BIND_KYOUSAI_CONTRACT', handle_bind_kyousai_contract),

    // takeEvery('COMPLETED_CHECKED', handle_completed_checked),

    // takeEvery('ALL_SELECTED', handle_all_selected),

    // takeEvery('CHECK_COMPLETED', handle_check_completed),

    // takeEvery('CHECK_COMPLETED_CANCEL', handle_check_completed_cancel),

    // takeEvery('OWNER_TEL_CHECKED', handle_owner_tel_checked),

    // takeEvery('USERS_REQUEST', handleUsersRequest),
    // takeEvery('RENT_AGENTS_REQUEST', handleRentAgentsRequest),
    // takeEvery('RENT_M_REASONS_REQUEST', handleRentMReasonsRequest),
];
// export default masterSaga;

function* handle_get_direct_debit_types(action: any): any {
    const state = yield select();

    // let search_form = state.ContractCheck.search_form
    // yield put(change_search_loading(true))

    // let search_id = state.kyousaiReducer.search_id
    const { payload, error } = yield call(furi_list_api.alllist, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {

        yield put(change_direct_debit_types(payload));
    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}

function* handle_get_kozalist(action: any): any {
    const state = yield select();

    // let search_form = state.ContractCheck.search_form
    // yield put(change_search_loading(true))

    // let search_id = state.kyousaiReducer.search_id
    const { payload, error } = yield call(furi_list_api.kozalist, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {

        yield put(change_kozalist(payload));
    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}


function* handle_get_direct_debit_list(action: any): any {
    const state = yield select();
    yield put(change_direct_debit_loading(true));
    // let search_form = state.ContractCheck.search_form
    // yield put(change_search_loading(true))

    // let search_id = state.kyousaiReducer.search_id

    const { payload, error } = yield call(furi_list_api.list, state.DirectDebitCheck.direct_debit_search_form.no);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)
        // alert(payload.current.length)
        yield put(change_direct_debit_list(payload));
        const { payloadpre, errorpre } = yield call(furi_list_api.prelist, state.DirectDebitCheck.direct_debit_search_form.no);

        if (payloadpre && !errorpre) {

            // const { payloadpre2, errorpre2 } = yield call(furi_list_api.pre2list, state.DirectDebitCheck.direct_debit_search_form.no);

            // if (payloadpre2 && !errorpre2) {
            const { money1, errormoney1 } = yield call(furi_list_api.moneylist, state.DirectDebitCheck.direct_debit_search_form.no);

            if (money1 && !errormoney1) {

                const { money2, errormoney2 } = yield call(furi_list_api.moneylist2, state.DirectDebitCheck.direct_debit_search_form.no);

                if (money2 && !errormoney2) {


                    const { money3, errormoney3 } = yield call(furi_list_api.moneylist3, state.DirectDebitCheck.direct_debit_search_form.no);

                    if (money3 && !errormoney3) {

                        const { kaiyaku, errorkaiyaku } = yield call(furi_list_api.kaiyakulist, state.DirectDebitCheck.direct_debit_search_form.no);

                        if (kaiyaku && !errorkaiyaku) {

                            const { start, errorstart } = yield call(furi_list_api.startlist, state.DirectDebitCheck.direct_debit_search_form.no);

                            if (start && !errorstart) {

                                //前月解約　で今月立ってるもの


                                // サーバーからのレスポンスデータによる分岐処理
                                // if (payload2 && !error2) {
                                console.log(money1.length)
                                // alert(payload.length)
                                let pay: any = []
                                // payload.map(async function (value: any) {
                                //     const sh = payloadpre.filter((a: any) => parseInt(a.kinyu_no) === parseInt(value.kinyu_no) && parseInt(a.ten_no) === parseInt(value.ten_no) && parseInt(a.kys_no) === parseInt(value.kys_no) && parseInt(a.koza_no) === parseInt(value.koza_no))
                                //     if (sh[0]) {

                                //         // return null
                                //     } else {
                                //         if (parseInt(value.gak)) {
                                //             value.gak = parseInt(value.gak)
                                //             pay.push(value)
                                //         }
                                //     }

                                // })
                                yield put(change_addlist(start));



                                // let deletelist: any = []
                                // payload.old.map(async function (value: any) {
                                //     const sh = payload.current.filter((a: any) => parseInt(a.kinyu_no) === parseInt(value.kinyu_no) && parseInt(a.ten_no) === parseInt(value.ten_no) && parseInt(a.kys_no) === parseInt(value.kys_no) && parseInt(a.koza_no) === parseInt(value.koza_no))
                                //     if (sh[0]) {


                                //         // return null
                                //     } else {

                                //         if (parseInt(value.gak)) {
                                //             value.gak = parseInt(value.gak)
                                //             deletelist.push(value)
                                //         }
                                //     }

                                // })
                                // alert(kaiyaku.length)
                                let deletelist: any = []
                                kaiyaku.map(async function (value: any) {
                                    // const sh = payload.current.filter((a: any) => a.kai_ymd !== null)
                                    // if (sh[0]) {

                                    // parseInt(
                                    //     // return null
                                    // } else {

                                    // if (parseInt(value.gak)) {
                                    value.gak = parseInt(value.gak)
                                    deletelist.push(value)
                                    // }
                                })

                                // })


                                yield put(change_deletelist(deletelist));


                                let changelist: any = []
                                yield put(change_pre_month_list(payloadpre));
                                yield put(change_this_month_list(payload));
                                payload.map(async function (valuechange: any) {
                                    // const sh = payloadpre.filter((a: any) => parseInt(a.kinyu_no) === parseInt(valuechange.kinyu_no) && parseInt(a.ten_no) === parseInt(valuechange.ten_no) && parseInt(a.kys_no) === parseInt(valuechange.kys_no) && parseInt(a.koza_no) === parseInt(valuechange.koza_no))
                                    // if (sh[0]) {//同じ契約があった場合
                                    // 
                                    // if (parseInt(sh[0].gak) !== parseInt(valuechange.gak)) {//金額が違う
                                    var money1sum = 0
                                    var suidou1 = 0
                                    var fkae_sqno1 = 0
                                    var koumoku: any = []
                                    // money1.filter((a: any) => parseInt(a.bk_no) === parseInt(valuechange.bk_no) && a.hy_no === valuechange.hy_no && parseInt(a.kys_no) === parseInt(valuechange.kys_no) && parseInt(a.ky_no) === parseInt(valuechange.ky_no)).map(function (value: any) {
                                    money1.filter((a: any) => parseInt(a.kys_no) === parseInt(valuechange.kys_no)).map(function (value: any) {


                                        if (value.nkin_no != 5010) {

                                            money1sum = money1sum + Number(value.sq_gak) + Number(value.sq_zeigak)

                                        } else {

                                            suidou1 = suidou1 + Number(value.sq_gak) + Number(value.sq_zeigak)

                                        }
                                        fkae_sqno1 = value.fkae_sqno
                                        var koumokuexist = 0
                                        // money2.filter((a: any) => parseInt(a.bk_no) === parseInt(valuechange.bk_no) && a.hy_no === valuechange.hy_no && parseInt(a.kys_no) === parseInt(valuechange.kys_no) && parseInt(a.ky_no) === parseInt(valuechange.ky_no)).map(function (values: any) {
                                        money2.filter((a: any) => parseInt(a.kys_no) === parseInt(valuechange.kys_no)).map(function (values: any) {

                                            if (value.nkin_no == values.nkin_no && (Number(value.sq_gak) + Number(value.sq_zeigak)) != (Number(values.sq_gak) + Number(values.sq_zeigak))) {
                                                if (koumoku.indexOf(value.nkin_name) === -1) {
                                                    koumoku.push(value.nkin_name)
                                                }

                                            }
                                            if (value.nkin_no == values.nkin_no) {
                                                koumokuexist = 1
                                            }
                                        })

                                        if (koumokuexist == 0) {

                                            if (koumoku.indexOf(value.nkin_name) === -1) {
                                                koumoku.push(value.nkin_name)
                                            }

                                        }
                                    })






                                    var money2sum = 0
                                    var fkae_sqno2 = 0
                                    // money2.filter((a: any) => parseInt(a.bk_no) === parseInt(valuechange.bk_no) && a.hy_no === valuechange.hy_no && parseInt(a.kys_no) === parseInt(valuechange.kys_no) && parseInt(a.ky_no) === parseInt(valuechange.ky_no)).map(function (value: any) {
                                    money2.filter((a: any) => parseInt(a.kys_no) === parseInt(valuechange.kys_no)).map(function (value: any) {

                                        if (value.nkin_no != 5010) {

                                            money2sum = money2sum + Number(value.sq_gak) + Number(value.sq_zeigak)

                                        }
                                        fkae_sqno2 = value.fkae_sqno

                                        var koumokuexist = 0
                                        // money1.filter((a: any) => parseInt(a.bk_no) === parseInt(valuechange.bk_no) && a.hy_no === valuechange.hy_no && parseInt(a.kys_no) === parseInt(valuechange.kys_no) && parseInt(a.ky_no) === parseInt(valuechange.ky_no)).map(function (values: any) {
                                        money1.filter((a: any) => parseInt(a.kys_no) === parseInt(valuechange.kys_no)).map(function (values: any) {

                                            if (value.nkin_no == values.nkin_no && (Number(value.sq_gak) + Number(value.sq_zeigak)) != (Number(values.sq_gak) + Number(values.sq_zeigak))) {
                                                if (koumoku.indexOf(value.nkin_name) === -1) {
                                                    koumoku.push(value.nkin_name)
                                                }
                                            }
                                            if (value.nkin_no == values.nkin_no) {
                                                koumokuexist = 1
                                            }
                                        })

                                        if (koumokuexist == 0) {

                                            if (koumoku.indexOf(value.nkin_name) === -1) {
                                                koumoku.push(value.nkin_name)
                                            }

                                        }

                                    })
                                    var suidou2 = 0

                                    // money3.filter((a: any) => parseInt(a.bk_no) === parseInt(valuechange.bk_no) && a.hy_no === valuechange.hy_no && parseInt(a.kys_no) === parseInt(valuechange.kys_no) && parseInt(a.ky_no) === parseInt(valuechange.ky_no)).map(function (value: any) {
                                    money3.filter((a: any) => parseInt(a.kys_no) === parseInt(valuechange.kys_no)).map(function (value: any) {

                                        if (value.nkin_no == 5010) {

                                            suidou2 = suidou2 + Number(value.sq_gak) + Number(value.sq_zeigak)

                                        }

                                    })

                                    if (money1sum !== money2sum) {
                                        valuechange.gak2 = money2sum
                                        valuechange.no2 = fkae_sqno2
                                        valuechange.gak = money1sum
                                        valuechange.sa = money1sum - money2sum
                                        valuechange.sa = Number(money1sum) - Number(money2sum)
                                        valuechange.koumoku = koumoku.join(',');
                                        changelist.push(valuechange)
                                    } else {
                                        var suidou1check = suidou1 > 0 ? 1 : 0
                                        var suidou2check = suidou2 > 0 ? 1 : 0
                                        if (suidou1check != suidou2check) {
                                            // valuechange.gak2 = 
                                            // valuechange.no2 = sh[0].no
                                            // valuechange.gak = parseInt(valuechange.gak)
                                            valuechange.sa = "水道相違"
                                            valuechange.koumoku = "水道料"
                                            changelist.push(valuechange)
                                        }
                                    }
                                    // }


                                    // return null
                                    // } else {


                                    // }

                                })


                                payloadpre.map(async function (valuechange: any) {
                                    // const sh = payloadpre.filter((a: any) => parseInt(a.kinyu_no) === parseInt(valuechange.kinyu_no) && parseInt(a.ten_no) === parseInt(valuechange.ten_no) && parseInt(a.kys_no) === parseInt(valuechange.kys_no) && parseInt(a.koza_no) === parseInt(valuechange.koza_no))
                                    var money1exist = 0
                                    // money1.filter((a: any) => parseInt(a.bk_no) === parseInt(valuechange.bk_no) && a.hy_no === valuechange.hy_no && parseInt(a.kys_no) === parseInt(valuechange.kys_no) && parseInt(a.ky_no) === parseInt(valuechange.ky_no)).map(function (value: any) {
                                    money1.filter((a: any) => parseInt(a.kys_no) === parseInt(valuechange.kys_no)).map(function (value: any) {

                                        if (value.nkin_no) {
                                            money1exist = 1
                                        }
                                    })

                                    var money2sum = 0
                                    var fkae_sqno2 = 0
                                    // money2.filter((a: any) => parseInt(a.bk_no) === parseInt(valuechange.bk_no) && a.hy_no === valuechange.hy_no && parseInt(a.kys_no) === parseInt(valuechange.kys_no) && parseInt(a.ky_no) === parseInt(valuechange.ky_no)).map(function (value: any) {
                                    money2.filter((a: any) => parseInt(a.kys_no) === parseInt(valuechange.kys_no)).map(function (value: any) {

                                        if (value.nkin_no != 5010) {
                                            money2sum = money2sum + Number(value.sq_gak) + Number(value.sq_zeigak)
                                        }
                                        fkae_sqno2 = value.fkae_sqno

                                    })
                                    if (money1exist == 0 && money2sum != 0) {
                                        valuechange.sa = "今回なし"
                                        valuechange.koumoku = "今回なし"
                                        valuechange.gak2 = money2sum
                                        valuechange.no2 = fkae_sqno2
                                        valuechange.gak = 0
                                        valuechange.sa = money2sum
                                        changelist.push(valuechange)
                                    }


                                })



                                yield put(change_changelist(changelist));

                                yield put(change_direct_debit_loading(false));




                                // } else {
                                //     alert(error)
                                //     //    // 失敗時アクション呼び出し
                                //     //    yield put(loginFailure(payload));
                                // }
                                // 成功時アクション呼び出し
                                // console.log(payload)
                                // let payloads = payload.map(function (value: any) {
                                //     // value.office_check_completed = value.office_check_completed_at ? true : false
                                //     value.office_check_completed = false
                                //     return value
                                // })
                                // alert()

                                // yield put(change_search_loading(false))
                            } else {
                                alert("えらstart")
                                alert(errorstart)
                                //    // 失敗時アクション呼び出し
                                //    yield put(loginFailure(payload));
                            }
                        } else {
                            alert("えらkaiyaku")
                            alert(errorkaiyaku)
                            //    // 失敗時アクション呼び出し
                            //    yield put(loginFailure(payload));
                        }



                    } else {
                        alert("えらmoney3")
                        alert(errormoney3)
                        //    // 失敗時アクション呼び出し
                        //    yield put(loginFailure(payload));
                    }

                } else {
                    alert("えらmoney2")
                    alert(errormoney2)
                    //    // 失敗時アクション呼び出し
                    //    yield put(loginFailure(payload));
                }
            } else {
                alert("えらmoney")
                alert(errormoney1)
                //    // 失敗時アクション呼び出し
                //    yield put(loginFailure(payload));
            }
            // } else {
            //     alert("えらold2")
            //     alert(errorpre2)
            //     //    // 失敗時アクション呼び出し
            //     //    yield put(loginFailure(payload));
            // }

        } else {
            alert("えらold")
            alert(errorpre)
            //    // 失敗時アクション呼び出し
            //    yield put(loginFailure(payload));
        }

    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}


function* handle_get_direct_debit_details(action: any): any {
    const state = yield select();
    yield put(change_direct_debit_details([]));
    // let search_form = state.ContractCheck.search_form
    // yield put(change_search_loading(true))

    // let search_id = state.kyousaiReducer.search_id
    const { payload, error } = yield call(furi_list_api.details, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {

        yield put(change_direct_debit_details(payload));
    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}
// function* handle_get_pre_direct_debit_list(action: any) {
//     const state = yield select();

//     // let search_form = state.ContractCheck.search_form
//     // yield put(change_search_loading(true))

//     // let search_id = state.kyousaiReducer.search_id
//     const { payload, error } = yield call(furi_list_api.list, state.RemittanceLogCheck.remittancelogcheck_search_form);

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {

//         const { payload2, error2 } = yield call(furi_list_api.list, { so_ymd: state.RemittanceLogCheck.remittancelogcheck_search_form.so_ymd });

//         // サーバーからのレスポンスデータによる分岐処理
//         if (payload2 && !error2) {
//             let pay = payload.map(function (value: any) {
//                 const sh = payload2.filter((a: any) => parseInt(a.so_no) === parseInt(value.so_no) && parseInt(a.sokoza_no) === parseInt(value.sokoza_no) && parseInt(a.bk_no) === parseInt(value.bk_no))
//                 if (sh[0]) {
//                     value.so_gak2 = sh[0].so_gak !== ".0000" ? parseInt(sh[0].so_gak) - (sh[0].kjsh_gak ? parseInt(sh[0].kjsh_gak) : 0) - (sh[0].ftesu_gak ? parseInt(sh[0].ftesu_gak) : 0) : 0 - (sh[0].kjsh_gak ? parseInt(sh[0].kjsh_gak) : 0) - (sh[0].ftesu_gak ? parseInt(sh[0].ftesu_gak) : 0)
//                 } else {
//                     value.so_gak2 = 0
//                 }
//                 return value
//             })
//             // yield put(change_owner_remittance_check_logs(pay));
//         } else {
//             alert(error)
//             //    // 失敗時アクション呼び出し
//             //    yield put(loginFailure(payload));
//         }
//         // 成功時アクション呼び出し
//         // console.log(payload)
//         // let payloads = payload.map(function (value: any) {
//         //     // value.office_check_completed = value.office_check_completed_at ? true : false
//         //     value.office_check_completed = false
//         //     return value
//         // })
//         // alert()

//         // yield put(change_search_loading(false))

//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }
// }